import PortalContainer from '../global/PortalContainer';

const PortalRoot = () => <PortalContainer />

export default PortalRoot;